import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { whatsappLink } from '../utils/whatsapp';
interface WhatsAppCtaProps {
  label?: string;
  message?: string;
  size?: 'md' | 'lg';
  className?: string;
}
export function WhatsAppCta({
  label = '¡¡Consulta ahora!!',
  message,
  size = 'md',
  className = ''
}: WhatsAppCtaProps) {
  const sizing = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  return <a href={whatsappLink(message)} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-3 whitespace-nowrap rounded-full bg-wa font-semibold uppercase tracking-wide text-[#062b12] shadow-candle transition-[transform,background-color] duration-150 ease-out hover:bg-[#1fbb59] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-soft active:scale-[0.98] ${sizing} ${className}`} data-id="element-133" data-mp="10j9zzhibru4h">
      <MessageCircleIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-134" data-mp="37e5ai34ut9g9" />
      {label}
    </a>;
}